"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var react_components_1 = require("@apollo/react-components");
var component_button_1 = __importDefault(require("@doordash/component-button"));
var component_modal_1 = require("@doordash/component-modal");
var React = __importStar(require("react"));
var App_1 = __importDefault(require("../../App/App"));
var apollo_1 = require("../utils/apollo");
var enums_1 = require("../utils/enums");
var RiskModal = function (_a) {
    var children = _a.children, disableDismiss = _a.disableDismiss, onCloseTracking = _a.onCloseTracking, primaryActionText = _a.primaryActionText, renderContentHeader = _a.renderContentHeader, size = _a.size, subtitle = _a.subtitle, title = _a.title;
    var _b = React.useContext(App_1["default"]), client = _b.client, dispatch = _b.dispatch, language = _b.language, proxyOverride = _b.proxyOverride, state = _b.state, authToken = _b.authToken;
    var apolloClient = client || apollo_1.getApolloClient(language, proxyOverride, authToken);
    var _c = __read(React.useState(false), 2), isSubmitting = _c[0], setSubmissionState = _c[1];
    var submitState = isSubmitting
        ? component_button_1["default"].States.Loading
        : component_button_1["default"].States.Default;
    return (React.createElement(component_modal_1.Modal, { actionsFillContainer: true, hasCloseButton: !disableDismiss && !isSubmitting, headerAlignment: component_modal_1.Modal.HeaderAlignment.Center, onClose: function () {
            onCloseTracking(state.workflow);
            if (typeof state.onClose === 'function') {
                state.onClose();
            }
            dispatch({ type: enums_1.RiskActions.Reset });
        }, primaryAction: primaryActionText && {
            onClick: function () { return setSubmissionState(true); },
            text: primaryActionText,
            buttonProps: {
                state: submitState
            }
        }, renderContentHeader: renderContentHeader, shouldCloseOnEscapePress: !disableDismiss && !isSubmitting, shouldCloseOnOverlayClick: !disableDismiss && !isSubmitting, size: size, subtitle: subtitle, title: title },
        React.createElement(react_components_1.ApolloProvider, { client: apolloClient }, children(isSubmitting, setSubmissionState))));
};
exports["default"] = RiskModal;
